import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';

export class ErrorMessage {
  constructor(
    public category: string,  // Uppercase undescore, e.g. LOGIN_ERROR
    public message?: string,  // Short summary, e.g. `Http failure response for https://localhost:4200/ws/user/sign/in/google: 400 Bad Request`
    public log?: string       // Long summary
  ) { }
}

@Injectable({
  providedIn: 'root'
})
export class ErrorLoggingService {
  log: Record<string, boolean> = {};

  constructor(private http: HttpClient) { }

  logError(error: ErrorMessage, dedupe = false) {
    const key = `${error.category}${error.message}`;

    if (dedupe && this.log[key]) {
      return of();
    }
    

    this.log[key] = true;
    return this.http.post(`/ws/human-error`, error);
  }
}
